import { render, staticRenderFns } from "./CustomSelectionEditView.vue?vue&type=template&id=2b3cbfe3&scoped=true&"
import script from "./CustomSelectionEditView.vue?vue&type=script&lang=js&"
export * from "./CustomSelectionEditView.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectionEditView.vue?vue&type=style&index=0&id=2b3cbfe3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3cbfe3",
  null
  
)

export default component.exports